import { type ReactNode } from "react";
import { cn } from "@/lib/cn";

interface Props {
  title: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function Empty({ title, description, icon, action, className }: Props) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 px-6 py-12 text-center", className)}>
      {icon ? <div className="rounded-full bg-surface-2 p-3 text-muted-fg">{icon}</div> : null}
      <div>
        <p className="text-sm font-medium text-fg">{title}</p>
        {description ? <p className="mt-1 text-xs text-muted-fg">{description}</p> : null}
      </div>
      {action}
    </div>
  );
}
